/*! this is bit of a hack to load the file via webpack */
var $ = require('./jquery-3.5.1.js');
window.$ = $;
window.jQuery = $;
